let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5j9df"), load("6qah4"), load("aZinD"), load("34xNu"), load("h3G8d")]).then(() => parcelRequire('cul1e'));